
/**
 * ResetStylesProcessor - Creates reset styles to prevent WordPress theme interference
 */
export class ResetStylesProcessor {
  static createResetStyles(): string {
    return `
      /* Reset styles to prevent WordPress theme interference */
      .onexip-calculator-container h1, 
      .onexip-calculator-container h2, 
      .onexip-calculator-container h3, 
      .onexip-calculator-container h4, 
      .onexip-calculator-container h5, 
      .onexip-calculator-container h6,
      .onexip-calculator-container p,
      .onexip-calculator-container ul,
      .onexip-calculator-container ol,
      .onexip-calculator-container li,
      .onexip-calculator-container div,
      .onexip-calculator-container span,
      .onexip-calculator-container input,
      .onexip-calculator-container select,
      .onexip-calculator-container textarea {
        margin: 0 !important;
        padding: 0 !important;
        font-family: inherit !important;
        font-size: inherit !important;
        line-height: inherit !important;
        color: inherit !important;
        border: none !important;
        background: none !important;
        box-shadow: none !important;
        text-transform: none !important;
        max-width: 100% !important;
      }
    `;
  }
}
